<template>
  <div class="my-class-bg-color">
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
  name: 'App'
});
</script>

<style>
#app {
  height: 100%;
}
/**缩放有错误，这个可以屏蔽掉 */
#webpack-dev-server-client-overlay {
  display: none !important;
}

</style>